<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Benefit</v-tab>
    <v-tab v-show="showBenefitTab" @click="resetTab(2)">Benefit Info</v-tab>
    <v-tab v-show="showFactorTab" @click="resetTab(3)">Factor Info</v-tab>
    <v-tab v-show="showRateTab">Rate Info</v-tab>
    <v-tab-item>
      <tariff-benefit-list :fetchBenefit="fetchBenefitList" :ids="ids"  @resetTab="resetTab" @doReview="tariffBenefitReview" @doNew="tariffBenefitNew"></tariff-benefit-list>
    </v-tab-item>
    <v-tab-item>
      <tariff-benefit-form :ids="ids" @resetTab="resetTab"></tariff-benefit-form>
      <tariff-factor-list v-if="ids.benefit != 'new'" :fetchFactor="fetchFactorList" :ids="ids"  @resetTab="resetTab" @doReview="doFactReview" @doNew="doFactNew"></tariff-factor-list>
    </v-tab-item>
    <v-tab-item>
      <tariff-factor-form :ids="ids" @resetTab="resetTab"></tariff-factor-form>
      <tariff-rate-list v-if="ids.seqNo != 'new'" :fetchRate="fetchRateList" :ids="ids"  @resetTab="resetTab" @doReview="doRateReview" @doNew="doRateNew"></tariff-rate-list>
    </v-tab-item>
    <v-tab-item>
      <tariff-rate-form :ids="ids" @resetTab="resetTab"></tariff-rate-form>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TariffBenefitList from '@/components/parameters/rate-management/scheme/pkgTariff/list/TariffBenefitList'
import TariffBenefitForm from '@/components/parameters/rate-management/scheme/pkgTariff/form/TariffBenefitForm'
import TariffFactorList from '@/components/parameters/rate-management/scheme/pkgTariff/list/TariffFactorList'
import TariffFactorForm from '@/components/parameters/rate-management/scheme/pkgTariff/form/TariffFactorForm'
import TariffRateList from '@/components/parameters/rate-management/scheme/pkgTariff/list/TariffRateList'
import TariffRateForm from '@/components/parameters/rate-management/scheme/pkgTariff/form/TariffRateForm'
export default {
  data () {
    return {
      tabMenu: 0,
      fetchBenefitList: false,
      fetchFactorList: false,
      fetchRateList: false,
      showBenefitTab: false,
      showFactorTab: false,
      showRateTab: false,
      ids: {
        scheme: null,
        planNo: null,
        busCls: null,
        tarf: null,
        benefit: null,
        benEffDate: null,
        seqNo: null,
        factEffDate: null,
        rateEffDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null,
        fact1Desc: null,
        fact2Desc: null,
        fact3Desc: null,
        fact4Desc: null,
        fact5Desc: null,
        fact6Desc: null
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    resetTab(tab) {
      switch (tab) {
        case 2: {
          this.tabMenu = 1
          this.ids.seqNo = null
          this.fetchBenefitList = false
          this.fetchFactorList = true
          this.fetchRateList = false
          this.showBenefitTab = true
          this.showFactorTab = false
          this.showRateTab = false
          break
        }
        case 3: {
          this.tabMenu = 2
          this.fetchBenefitList = false
          this.fetchFactorList = false
          this.fetchRateList = true
          this.showBenefitTab = true
          this.showFactorTab = true
          this.showRateTab = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.benefit = null
          this.fetchBenefitList = true
          this.fetchFactorList = false
          this.showBenefitTab = false
          this.showFactorTab = false
          this.showRateTab = false
        }
      }
    },
    async tariffBenefitReview(data) {
      this.ids.scheme = this.scheme
      this.ids.planNo = data.planNo
      this.ids.busCls = data.busCls
      this.ids.tarf = data.tarf
      this.ids.benefit = data.benefit
      this.ids.benEffDate = data.effDate
      this.showBenefitTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = true
      this.fetchRateList = false
      this.tabMenu = 1
    },
    tariffBenefitNew() {
      this.ids.scheme = this.scheme
      this.ids.benefit = 'new'
      this.ids.planNo = null
      this.ids.busCls = null
      this.ids.tarf = null
      this.ids.benEffDate = null
      this.showBenefitTab = true
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.tabMenu = 1
    },
    doFactReview(data) {
      this.ids.seqNo = data.seqNo
      this.ids.factEffDate = data.effDate
      this.ids.fact1Desc = data.fact1
      this.ids.fact2Desc = data.fact2
      this.ids.fact3Desc = data.fact3
      this.ids.fact4Desc = data.fact4
      this.ids.fact5Desc = data.fact5
      this.ids.fact6Desc = data.fact6
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = true
      this.showBenefitTab = true
      this.showFactorTab = true
      this.showRateTab = false
      this.tabMenu = 2
    },
    doFactNew() {
      this.ids.seqNo = 'new'
      this.ids.factEffDate = null
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.showBenefitTab = true
      this.showFactorTab = true
      this.showRateTab = false
      this.tabMenu = 2
    },
    doRateReview(data) {
      this.ids.rateEffDate = data.effDate
      this.ids.fact1 = data.fact1
      this.ids.fact2 = data.fact2
      this.ids.fact3 = data.fact3
      this.ids.fact4 = data.fact4
      this.ids.fact5 = data.fact5
      this.ids.fact6 = data.fact6
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.showBenefitTab = true
      this.showFactorTab = true
      this.showRateTab = true
      this.tabMenu = 3
    },
    doRateNew() {
      this.ids.rateEffDate = 'new'
      this.fetchBenefitList = false
      this.fetchFactorList = false
      this.fetchRateList = false
      this.showBenefitTab = true
      this.showFactorTab = true
      this.showRateTab = true
      this.tabMenu = 3
    }
  },
  mounted() {
    this.ids.scheme = this.scheme
    this.fetchBenefitList = true
  },
  components: {
    TariffBenefitList,
    TariffBenefitForm,
    TariffFactorList,
    TariffFactorForm,
    TariffRateList,
    TariffRateForm
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
